<div class="container-fluid">
  <div class="mt-3">
    <h3>Payouts</h3>
  </div>
  <div class="mb-3">
    <searchbar #searchbar [title]="'Payouts'" [placeholder]="'Search Payouts'" [hasCollapsedFilters]="true"
               [sortFilterOptions]="sortFilter" (applyClicked)="applyFilterSortOptions($event)"
               (searched)="search($event)" [searchTipText]="'You can search by Payout ID.'"></searchbar>
  </div>
  <ng-container *ngIf="!loading">
    <ng-container *ngIf="totalElements === 0; else counter">
      <div class="row">
        <div class="col-12 col-md-8 offset-md-2">
          <div class="no-results">
            <h5><b>Not finding what you're searching for?</b></h5>
            <ul>
              <li>Check your spelling, or try fewer terms and more generic texts.</li>
              <li><a href="https://www.jjkane.com/contact-us/" target="_blank" >Contact Us</a> for more assistance.</li>
            </ul>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-template #counter>
      <div class="font-italic font-weight-light mb-3">
        Showing {{ totalElements > 10 ? (1 + (10 * page)) : 1 }} - {{ payouts.length >= 10  ? (10 + (10 * page)) : totalElements }} of {{totalElements}} Items
      </div>
    </ng-template>
  </ng-container>

  <ng-template #loadingCell>
    <div class="col">
      <div class="loading loading-text-field">&nbsp;</div>
    </div>
  </ng-template>

  <div class="w-100 header-row-wrap">
    <div class="row no-gutters">
      <div class="col-auto payout-id-col">Payout ID</div>
      <div class="col-auto auction-date-col">Auction Date</div>
      <div class="col-auto auction-col">Auction</div>
      <div class="col-auto total-auction-price-col">Total Auction Price</div>
      <div class="col-auto total-seller-net-col">Total Seller Net</div>
      <div class="col-auto tracking-info-col">Tracking Info</div>
      <div class="col-auto more-col">More</div>
    </div>
  </div>

  <mat-accordion class="striped-table">
    <mat-expansion-panel hideToggle *ngFor="let payout of payouts; let i = index" [ngClass]="{'gray': i % 2 === 0}">
      <mat-expansion-panel-header (click)="panelToggled(payout)">
        <div class="row no-gutters payout-details-row">
          <div *ngIf="!loading; else loadingCell" class="col-auto payout-id-col">
            <span class="mobile-label">Payout ID:</span>
            <a class="mb-1" (click)="clickDetail(payout)" [GA]="{event: {category: 'Payout Select', action: 'Click', label: 'Payouts'}}">{{ payout.id }}</a>
          </div>

          <div *ngIf="!loading; else loadingCell" class="col-auto auction-date-col">
            <span class="mobile-label">Auction Date:</span>
            {{ payout?.sale?.date | date: 'LL/d/yyyy' }}
          </div>

          <div *ngIf="!loading; else loadingCell" class="col-auto auction-col">
            <span class="mobile-label">Auction:</span>
            {{generateAuctionName(payout?.sale)}}
          </div>

          <div *ngIf="!loading; else loadingCell" class="col-auto total-auction-price-col">
            <span class="mobile-label">Total Auction Price:</span>
            {{ payout?.salePriceSubtotal - payout?.totalAdjustedNoSaleAmount | currency }}
          </div>

          <div *ngIf="!loading; else loadingCell"
            [class]="payout.sale.payoutsFinalized && payout.sellerNet > 0 ? 'finalized'
              : (payout.sellerNet < 0 && payout.sale.payoutsFinalized ? 'negative-seller-net' : 'not-finalized')"
            class="col-auto total-seller-net-col">

            <span class="mobile-label">Total Seller Net:</span>
            {{ !payout?.sale?.payoutsFinalized ? 'Pending' : payout?.sellerNet | currency}}
          </div>

          <div *ngIf="!loading; else loadingCell" class="col-auto tracking-info-col">
            <span class="mobile-label">Tracking Info:</span>
            <a *ngIf="generateTrackingLink(payout?.upsTrackingNumber); else unknownTrackingNumber"
                [href]="generateTrackingLink(payout?.upsTrackingNumber)" target="_blank"
                [GA]="{event: {category: 'Tracking Info Select', action: 'Click', label: 'Payouts'}}">{{ payout?.upsTrackingNumber }}</a>
            <ng-template #unknownTrackingNumber>{{ payout?.upsTrackingNumber }}</ng-template>
          </div>

          <div class="col-auto more-col">
            <fa-icon [icon]="payout === expandedPayout ? faChevronUp : faChevronDown"></fa-icon>
          </div>
        </div>
      </mat-expansion-panel-header>
      <div class="payout-panel-body">
        <div class="decorated"><span class="font-weight-bold">Reports</span></div>
        <div class="row pb-3">
          <div class="col-4 text-center">
            <div class="report-button" [class.downloading]="downloadingSellerTotalReport" *ngIf="!loading; else loadingCell" [GA]="{event: {category: 'Download Seller Total Report', action: 'Click', label: 'Payouts'}}" (click)="showSellerTotalReport(payout.accountId, payout.id)">
              <fa-icon *ngIf="!downloadingSellerTotalReport; else spinner" [icon]="faMoneyCheckAlt" size="2x"></fa-icon>
              <div>Seller Total Report</div>
            </div>
          </div>
          <div class="col-4 text-center">
            <div class="report-button" [class.downloading]="downloadingPayoutLetter" *ngIf="!loading; else loadingCell" [GA]="{event: {category: 'Download Payout Letter', action: 'Click', label: 'Payouts'}}" (click)="showPayoutLetter(payout.accountId, payout.id)">
              <fa-icon *ngIf="!downloadingPayoutLetter; else spinner" [icon]="faChartBar" size="2x"></fa-icon>
              <div>Payout Letter</div>
            </div>
          </div>
          <div class="col-4 text-center">
            <div class="report-button" [class.downloading]="downloadingPayoutDetailReport" *ngIf="!loading; else loadingCell" [GA]="{event: {category: 'Download Payout Detail Report', action: 'Click', label: 'Payouts'}}" (click)="showPayoutDetailReport(payout.accountId, payout.id)">
              <fa-icon *ngIf="!downloadingPayoutDetailReport; else spinner" [icon]="faChartPie" size="2x"></fa-icon>
              <div>Payout Detail Report</div>
            </div>
          </div>
          <ng-template #spinner>
            <div class="spinner-border">
              <span class="sr-only"></span>
            </div>
          </ng-template>
        </div>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
  <div class="mt-3">
    <pagination [pageSize]="pageSize" [numberOfItems]="totalElements" [index]="page" (paging)="pageChange($event)"></pagination>
  </div>
</div>
